import { FC, FormEvent, useRef } from 'react';
import { useState, useEffect } from 'react';
import { TextField, Button, Box } from '@mui/material';
import { IRepeaterForm } from '../repeater/Repeater';
import { BoothContact } from 'src/types/vendorBooth';
import TextLabel from '../TextLabel';

interface Props extends IRepeaterForm {
  onSave?: (formData: BoothContact) => void;
  data?: BoothContact;
}

const ContactsForm: FC<Props> = (props) => {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');

  const inEdit = useRef(false);

  useEffect(() => {
    if (inEdit.current === true && props.data?.inEdit === false) {
      //When the form goes from visible to hidden, save the data
      save();
    } else if (props.data) {
      setName(props.data.fullName ?? '');
      setEmail(props.data.emailAddress ?? '');
      setPhone(props.data.phoneNumber ?? '');
      inEdit.current = props.data.inEdit ?? false;
    }
  }, [props.data.fullName, props.data.emailAddress, props.data.phoneNumber, props.data.inEdit]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = (e?: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    props.onSave({
      fullName: name,
      emailAddress: email,
      phoneNumber: phone,
      key: props.data?.key ?? '',
    });
  };

  return (
    <form onSubmit={(e) => save(e)}>
      <Box sx={{ p: 4, background: '#ccc' }}>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <TextLabel>Name</TextLabel>
          <TextField value={name} required onChange={(e) => setName(e.target.value)} variant="outlined" sx={{ minWidth: 300 }}></TextField>
        </Box>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <TextLabel>Email</TextLabel>
          <TextField value={email} required onChange={(e) => setEmail(e.target.value)} variant="outlined" sx={{ minWidth: 300 }}></TextField>
        </Box>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <TextLabel>Phone</TextLabel>
          <TextField value={phone} onChange={(e) => setPhone(e.target.value)} variant="outlined" sx={{ minWidth: 300 }}></TextField>
        </Box>
        <Button variant="contained" type="submit">
          Submit
        </Button>
      </Box>
    </form>
  );
};

export default ContactsForm;
